import {action, computed, makeAutoObservable} from 'mobx';
import PubSub from "pubsub-js";

class DataItemStore {
    dataItems = [];
    //
    initialised = false;

    constructor() {
        makeAutoObservable(this);
    }

    get websiteConfig() {
        return this.getDataItem('website/configuration');
    }

    initialise = (dataItems) => {
        if (dataItems) {
            this.setDataItems(dataItems);
        }
        PubSub.subscribe('ws.in', (action, message) => {
            if (message.eventType === 'SINGLE_UPDATE') {
                if (message.type === 'engine.dataItem') {
                    this.updateSingleDataItem(message.payload);
                }
            }
        });
        this.initialised = true;
    }

    @action setDataItems(dataItems) {
        this.dataItems = dataItems;
    }

    @action updateSingleDataItem(dataItem) {
        const idx = this.dataItems.findIndex(d => d.path === dataItem.path);
        if (idx >= 0) {
            this.dataItems[idx] = dataItem;
        } else {
            this.dataItems.push(dataItem);
        }
    }

    @computed getDataItem(path) {
        const value = this.dataItems.find(d => d['path'] === path);
        if (value == null) {
            return null;
        }
        return value.data;
    }

    getCountries() {
        return this.getDataItem('general/countries');
    }

    getJurisdictions() {
        return this.getDataItem('general/jurisdictions');
    }

    getCounty(countryCode, countyCode) {
        const country = this.getCountry(countryCode);
        return country && country.counties && country.counties.filter(c => c.code === countyCode)[0];
    }

    getCountry(code) {
        return this.getCountries().filter(c => c.code === code)[0];
    }

    getCountyMap(countryCode) {
        const map = new Map();
        const country = this.getCountry(countryCode);
        country && country.counties && country.counties.forEach(c => map.set(c.code, c.name));
        return map;
    }

    getCountryMap() {
        return new Map(this.getCountries().map(c => [c.code, c.name]));
    }

    getCompanyTypes(countryCode) {
        const map = new Map();
        this.getJurisdictions()
            .filter(j => j.code.startsWith(countryCode))
            .forEach(j => {
                Object.entries(j.entityTypes).forEach(ct => {
                    if (!map.has(ct[0])) {
                        if (ct[1].suffix != null) {
                            map.set(ct[0], `${ct[1].name} (${ct[1].suffix})`)
                        } else {
                            map.set(ct[0], `${ct[1].name}`)
                        }
                    }
                });
            });
        return map;
    }

    getOfficerRoles(countryCode, includeCorporate = false) {
        const map = new Map();
        this.getJurisdictions()
            .filter(j => j.countryCode === countryCode)
            .forEach(j => {
                Object.entries(j.entityRoles).forEach(co => {
                    if (!map.has(co[0]) && (includeCorporate || !co[0].includes('CORPORATE'))) {
                        map.set(co[0], co[1].name)
                    }
                });
            });
        return map;
    }
}

export const dataItemStore = new DataItemStore();
